import PropTypes from 'prop-types';

export const CouponDetailsProps = PropTypes.shape({
  CouponValue: PropTypes.number.isRequired,
  ClassName: PropTypes.string.isRequired,
  CouponTypeId: PropTypes.number.isRequired,
  PercentOff: PropTypes.number.isRequired,
  ExpiryDate: PropTypes.string.isRequired,
  LimitForDaysToUseFromCustomerCreation: PropTypes.number.isRequired,
  CurrencyId: PropTypes.number.isRequired,
});

export const MultiCouponDetailsProps = PropTypes.shape({
  couponString: PropTypes.string.isRequired,
  couponStringType: PropTypes.string.isRequired,
  couponDetails: CouponDetailsProps.isRequired,
});
